module.exports = __webpack_public_path__ + "img/17.d4e64a56.jpg";